import {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  pharmetikaV2: {
    label: 'Pharmetika V2',
    functions: {
      createOrder: {
        version: 2,
        label: 'Create Order',
        middlewareHandler: 'pharmetika-v2',
        passPayload: true,
        pipelines: ['order']
      },
      handleWebhook: {
        version: 2,
        label: 'Handle Webhook',
        middlewareHandler: 'pharmetika-v2',
        passPayload: true,
        pipelines: ['webhook']
      }
    }
  }
} as const;

export const PharmetikaV2Config: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type PharmetikaV2FunctionConfiguration = MiddlewareConfigClass<
  typeof config.pharmetikaV2.functions
>;
